import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

export const ScrimWrapper = styled.div`
  position: absolute;
  inset-inline: 0;
  inset-block-end: 0;
  height: 65px;
  z-index: 2;
  pointer-events: none;
  /*
   * This wrapper carries the 'inverse' class so AScrimGradient resolves the
   * dark scrim tokens. The global 'div.inverse' theme rule also paints a solid
   * brand background (--t-brand-bg-color, e.g. #1c1c1c) plus a texture image;
   * neutralize both so only the translucent scrim shows through. The '&.inverse'
   * selector matches that global rule's specificity so the reset wins.
   */
  &.inverse {
    background-color: transparent;
    background-image: none;
  }
`;

export const ButtonIconWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;
`;
